import { MODAL_WIDTH_580 } from '@constants/modals';

export const emptyTableText = 'Select options and apply MO Branches';
export const consistencyCheckPageTitle = 'Consistency Check';
export const goldenSettingsFormWidth = MODAL_WIDTH_580;
export const consistencyCheckBranchesWidth = '80vw';
export const consistencyCheckSearchTooltip = 'Search by MO Branch Name';
export const goldenSettingsFormTitle = 'Manage Golden Setting';
